import yup from 'src/libraries/validator.library';

export const DistrictSchema = yup
  .object({
    key: yup.number(),
    value: yup.string().required(),
    relationship: yup.string().required(),
  })
  .defined();

export const DistrictFormSchema = yup
  .object({
    key: yup.number(),
    value: yup.string().required(),
    relationship: yup.string().required(),
  })
  .defined();

export const DistrictListPayloadSchema = yup
  .object({
    count: yup.number().defined(),
    rows: yup.array().of(DistrictSchema).defined(),
  })
  .defined();

export type IDistrict = yup.InferType<typeof DistrictSchema>;
export type IDistrictForm = yup.InferType<typeof DistrictFormSchema>;
